// extracted by mini-css-extract-plugin
export var collapsedSummary = "_l6-0";